// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host img {
  max-width: 80px;
  max-height: 60px;
  width: auto;
  height: auto;
  display: block;
  margin: auto;
}
:host .cant-find-beer {
  font-weight: normal;
  font-size: 18px;
}
:host .add-beer {
  font-size: 14px; /*0.8em;*/
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
